import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import DividendDocumentModalHeader from './components/DividendDocumentModalHeader';
import DividendDocumentModalBody from './components/DividendDocumentModalBody';
import { useDividendDocumentModal } from './context/DividendDocumentModalContext';
import DividendDocumentModalFooter from './components/DividendDocumentModalFooter';

const DividendDocumentModal: FC = () => {
  const { data } = useDividendDocumentModal();

  return (
    <>
      <DividendDocumentModalHeader />
      <DividendDocumentModalBody />
      <DividendDocumentModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default DividendDocumentModal;
